import { TablePlaceholder, TablePlaceholderProps } from "./TablePlaceholder"
import { IconProps } from "../../../../components/Icon"
import { classNames } from "../../../../lib/classNames"
import { LucideIconComponent, IconSizes } from "../LucideIcon"

export interface TableIconMessagePlaceholderProps
  extends Omit<TablePlaceholderProps, "children">,
    Pick<IconProps, "icon"> {
  iconClassName?: string
  message: string
}

export function TableIconMessagePlaceholder({
  icon,
  iconClassName,
  message,
  className,
  ...otherProps
}: TableIconMessagePlaceholderProps) {
  return (
    <TablePlaceholder {...otherProps}>
      <LucideIconComponent
        iconSize={IconSizes.ExtraExtraLarge}
        Icon={icon}
        className={iconClassName}
      />
      <p className={classNames("text-title-sm text-center", className)}>
        {message}
      </p>
    </TablePlaceholder>
  )
}
